import axios from 'axios';
import urls from './urls'


const axios_instance = axios.create({
	baseURL: urls.BASE_URL,
	// 50s deliberately sits below the backend's 120s gunicorn/nginx timeouts:
	// the client gives up first and shows an explicit "server took too long"
	// toast, instead of receiving a bare gateway error page (no CORS headers)
	// that the browser reports only as an opaque network/CORS failure.
	timeout: 50000,
});
export default axios_instance
